import script from "./card-body-product-info.vue?vue&type=script&setup=true&lang=js"
export * from "./card-body-product-info.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__